import React, { ComponentProps } from 'react';
import { asBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Namespace } from '../../../translation/namespace';

type ChildPageMetaInfoProps = {
  leadText?: string;
  publicationDate?: string;
  contentDate?: string;
};

function ChildPageMetaInfo({ leadText, publicationDate, contentDate }: ChildPageMetaInfoProps) {
  const { t } = useSonTranslation(Namespace.FaqList);
  const date = () => {
    if (publicationDate) return t('publicationDate');
    if (contentDate) return t('contentDate');
  };
  return (
    <div className="faq-list__lead-text font-regular-16-24">
      {leadText && <p>{leadText}</p>}
      {(publicationDate || contentDate) && (
        <p>
          <dfn className="faq-list__publication-date-dfn">{date()}: </dfn> {publicationDate && `${t('at')} `}
          <DateFormat date={(publicationDate || contentDate) as string} format={DateFormats.DATE} />
        </p>
      )}
    </div>
  );
}

export const ChildPageMetaInfoBlock = asBlock(ChildPageMetaInfo, BlockType.childPageMetaInfo);
export type ChildPageMetaInfoBlock = ComponentProps<typeof ChildPageMetaInfoBlock>;
